const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    layout: "/admin",
  },
  {
    path: "/subscriber",
    name: "Subscriber",
  },
  {
    path: "/packages",
    name: "Packages",
  },

  {
    path: "/",
    name: "Revenue",
  },
  {
    path: "/contactleads",
    name: "Contact Leads",
  },
  {
    path: "/Communication",
    name: "Communication",
  },
  {
    path: "/ProductUsage ",
    name: "Product Usage ",
  },
  {
    path: "/CustomerSupport",
    name: "Customer Support",
  },
  {
    path: "/Feedback",
    name: "Feedback and Suggestions:",
  },

  {
    path: "/SalesConversion",
    name: "Sales and Conversion Metrics ",
  },
  {
    path: "/MarketingMetrics",
    name: "Marketing Metrics",
  },
  {
    path: "/SystemHealth",
    name: "System Health and Performance",
  },
  {
    path: "/Settings",
    name: "Settings",
  },
];

export default dashboardRoutes;
